import React from 'react';

const Footer = () => {
  const handleScroll = (e, href) => {
    e.preventDefault();
    const element = document.querySelector(href);
    if (element) {
      window.scrollTo({
        top: element.offsetTop - 80,
        behavior: "smooth"
      });
    }
  };

  return (
    <footer className="bg-slate-50 border-t border-slate-200 py-16">
      <div className="max-w-7xl mx-auto px-6">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-12 mb-12">
          <div className="col-span-1 md:col-span-2">
            <a href="#home" onClick={(e) => handleScroll(e, '#home')} className="text-xl font-semibold tracking-tighter text-slate-900 block mb-6">
              Villarosa<span className="text-slate-400">.</span>
            </a>
            <p className="text-slate-500 text-sm leading-relaxed max-w-sm">
              A collective of professionals dedicated to systems thinking, governance, and digital trust. Bridging the gap between technical complexity and human impact.
            </p>
          </div>
          
          <div>
            <h4 className="font-medium text-slate-900 mb-4">Navigation</h4>
            <ul className="space-y-3 text-sm text-slate-500">
              <li><a href="#home" onClick={(e) => handleScroll(e, '#home')} className="hover:text-slate-900 transition-colors">Home</a></li>
              <li><a href="#expertise" onClick={(e) => handleScroll(e, '#expertise')} className="hover:text-slate-900 transition-colors">Expertise</a></li>
              <li><a href="#team" onClick={(e) => handleScroll(e, '#team')} className="hover:text-slate-900 transition-colors">Team</a></li>
              <li><a href="#contact" onClick={(e) => handleScroll(e, '#contact')} className="hover:text-slate-900 transition-colors">Contact</a></li>
            </ul>
          </div>

          <div>
            <h4 className="font-medium text-slate-900 mb-4">Connect</h4>
            <ul className="space-y-3 text-sm text-slate-500">
              <li><a href="#" className="hover:text-slate-900 transition-colors">LinkedIn</a></li>
              <li><a href="mailto:hello@villarosa.tech" className="hover:text-slate-900 transition-colors">Email Us</a></li>
            </ul>
          </div>
        </div>
        
        <div className="pt-8 border-t border-slate-200 flex flex-col md:flex-row justify-between items-center text-xs text-slate-400">
          <p>&copy; {new Date().getFullYear()} The Villarosa Collective. All rights reserved.</p>
          <div className="flex space-x-6 mt-4 md:mt-0">
            <a href="#" className="hover:text-slate-600">Privacy Policy</a>
            <a href="#" className="hover:text-slate-600">Terms of Service</a>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;